<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="">Tags</label>
          <ng-select
            [items]="tags"
            formControlName="tags"
            bindValue="id"
            [searchFn]="customTagsSearchFn"
            multiple="true"
          >
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <span
                class="ng-value-icon right"
                (click)="clear(item)"
                aria-hidden="true"
                >×</span
              >
              <span [innerHTML]="item.name" class="d-inline"></span>
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              <h6 [innerHTML]="item.name"></h6>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
    <!-- <h4 *ngIf="rfq_ids && rfq_ids.length > 0" class="selected text-center">
      {{ rfq_ids.length }} SKUs selected
    </h4> -->
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <button
      type="button"
      (click)="onSubmit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success btn-elevate"
    >
      <i class="fas fa-save"></i> Confirm
    </button>
  </div>
</form>
